import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class UnavailableRoom extends Component {
  constructor(props) {
    super(props);
  }

  goBack() {
    window.history.go(-1);
    return false;
  }

  render() {
    return (
        <div className="box_general rooms__unavailable">
          <div className="header_box">
            <h2 className="d-inline-block">Videoconferencia</h2>
            <hr/>
          </div>

          <div className="list_general text-center">
            <i className={"fa fa-clock margin_20"}/>
            <h3 className={"h3"}>No Disponible</h3>
            <p className={"rooms__unavailable-message"}>
              Esta videoconferencia aún no se encuentra disponible. La fecha asignada es <strong>{this.props.appointment.start_time}</strong>.
              Recuerda ingresar a la videoconferencia al menos 5 minutos antes de la hora de comienzo.
            </p>
            <p className={"margin_20"}>
              <a href="#" className={"btn_1"} onClick={this.goBack}>VOLVER</a>
            </p>
          </div>
        </div>
    );
  }
}

UnavailableRoom.propTypes = {
  appointment: PropTypes.shape({
    patient: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    professional: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    start_time: PropTypes.string,
  }).isRequired,
};

export default UnavailableRoom;
